import axios from "axios";
import { environment } from "../global/environment";
import { getAccessToken } from "../utils/accessToken";

const instance = axios.create({
  baseURL: environment.apiUrl,
  headers: { Authorization: `Bearer ${getAccessToken()}` },
});
export default instance;
